export * from './taxonomy';
export var GLOBAL_SHARED_STATE_KEY = '__nwAnalyticsState';
export var BROWSER_EVENTS_ATTACHED_KEY = '__browserEventsAttached';